import React from 'react';

import type { PaymentItemDetails } from '../../generated-types';
import { useSigningContext } from '../../signingContext/signingContext';
import { FormattedFuturePayment } from '../../utils/mapper/futurepaymentsUtil';
import PaymentDetailsModal from '../PaymentDetailsModal/PaymentDetailsModal';
import FuturePaymentDetailsView from './FuturePaymentDetailsView';

type Props = {
    futurePaymentDetails: { data: PaymentItemDetails | undefined; isLoading: boolean };
    futurePayment: FormattedFuturePayment;
    openEditModalState: [boolean, React.Dispatch<boolean>];
    paymentButtonState: [boolean, React.Dispatch<boolean>];
    onClose: () => void;
    hideCloseButton?: boolean;
} & React.PropsWithChildren;

const FuturePaymentModal: React.FC<Props> = ({
    futurePaymentDetails,
    futurePayment,
    openEditModalState,
    paymentButtonState,
    onClose,
    hideCloseButton,
    children,
}) => {
    const { signingStatus } = useSigningContext();
    return (
        <PaymentDetailsModal
            id="futurePaymentDetailsTransfer"
            className="future-payment__eika-modal"
            openEditModalState={openEditModalState}
            open={!!futurePayment}
            onClose={onClose}
            isSuccess={signingStatus && signingStatus === 'COMPLETED'}
            editModalChildren={children}
            hideCloseButton={hideCloseButton}
        >
            <FuturePaymentDetailsView
                onClose={onClose}
                futurePaymentDetails={futurePaymentDetails}
                paymentButtonState={paymentButtonState}
                editModalState={openEditModalState}
                futurePayment={futurePayment}
            />
        </PaymentDetailsModal>
    );
};

export default FuturePaymentModal;
